import { InputSearch } from './InputSearch'
export default InputSearch;


export { skeletonInputSearch } from './input-search-skeleton';
export { InputSearch, InputSearchProps } from './InputSearch';
